export const DefaultLocale = 'en-US';
